import { render, staticRenderFns } from "./SamSelect.vue?vue&type=template&id=6f1e6249&scoped=true&"
import script from "./SamSelect.vue?vue&type=script&lang=js&"
export * from "./SamSelect.vue?vue&type=script&lang=js&"
import style0 from "./SamSelect.vue?vue&type=style&index=0&id=6f1e6249&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1e6249",
  null
  
)

export default component.exports